import { connect } from 'react-redux'

import { selectItem, setOffsetTop } from '../../../../../common/actions/layout'
import ItemCard from './'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    selectItem: itemId => {
      dispatch(selectItem(itemId))
    },
    resetOffsetTop: () => {
      dispatch(setOffsetTop(null))
    }
  }
}

const PhotoduneGridItemCardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemCard)

export default PhotoduneGridItemCardContainer
